export const DEFAULT_TITLES = ['Доступно', 'Выбрано']
export const DEFAULT_LOCALE = { itemUnit: '', itemsUnit: '', searchPlaceholder: 'Поиск' }
export const DEFAULT_LIST_STYLES = { width: '100%' }
export const DEFAULT_PAGINATION = { pageSize: 15, simple: true, showSizeChanger: false, showLessItems: false }
